import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { jobPipelineEndpoints } from '@/lib/api/endpoints';
import { jobPipelineKeys } from '@/lib/queryKeys';
import type { CreatePipelineDto, JobPipeline } from '@/types/pipeline';

export const useCreatePipeline = createMutationHook<JobPipeline, CreatePipelineDto>({
  mutationFn: (dto) =>
    apiPost<JobPipeline, CreatePipelineDto>(operationsClient, jobPipelineEndpoints.create(), dto),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: jobPipelineKeys.lists() });
    toast.success('Pipeline created');
  },
});
